import { IOrgStudios } from '~/ScreensOrganisation/OrganisationStudio/Studio.model';
import { CreationSource } from '~/Screens/Onboarding/IOnboardingData.model';

export const providerDataHelper = (studio: IOrgStudios, email = '', organisationId = '') => ({
  name: studio.name,
  email,
  providerCategoryId: studio.category,
  organisationId,
  isUSCMember: true,
  isOneFitMember: false,
  accessType: 'PartnerTool',
  creationSource: CreationSource.PartnerPortal,
  mainLocation: {
    country: studio.countryName,
    city: studio.city,
    latitude: studio?.latitude || 0,
    longitude: studio?.longitude || 0,
    street: studio.street,
    zip_code: studio?.zipCode || '',
  },
});
